import feather from "feather-icons";

const FeatherIcon = ({ name, className = "", color }) => {
  const icon = feather.icons[name];
  if (!icon) return null;
  return (
    <svg
      className={`feather-icon ${className}`}
      viewBox="0 0 24 24"
      dangerouslySetInnerHTML={{ __html: icon.contents }}
      style={color !== undefined ? { color } : { color: "var(--dark-purple)" }}
    />
  );
};

export default FeatherIcon;
